module.exports = __webpack_public_path__ + "img/bg2.9b6e50c6.png";